(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osb-landing"] && !Shopify.designMode) return;
  try {
    
  function loadOsbVimeoApi() {
    if (window.Vimeo?.Player) return Promise.resolve(window.Vimeo);
    if (window.osbVimeoApiPromise) return window.osbVimeoApiPromise;

    window.osbVimeoApiPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
      const script = existingScript || document.createElement('script');

      script.addEventListener('load', () => resolve(window.Vimeo), { once: true });
      script.addEventListener('error', reject, { once: true });

      if (!existingScript) {
        script.src = 'https://player.vimeo.com/api/player.js';
        script.async = true;
        document.head.appendChild(script);
      }
    });

    return window.osbVimeoApiPromise;
  }

  function initOsbLandings(scope = document) {
    scope.querySelectorAll('[data-osb-landing]:not([data-osb-ready])').forEach((section) => {
      section.setAttribute('data-osb-ready', '');

      const media = section.querySelector('[data-osb-media]');
      const options = section.querySelector('.osb-landing__video-options');
      const nativeTemplate = section.querySelector('[data-osb-native-video]');
      const joinButton = section.querySelector('[data-osb-open]');
      const joinPanel = section.querySelector('[data-osb-form]');
      const joinForm = joinPanel?.querySelector('form');
      const requiredFields = joinForm ? Array.from(joinForm.querySelectorAll('input[required]')) : [];
      const intro = section.querySelector('[data-osb-intro]');
      const introTextNode = intro?.querySelector('[data-osb-intro-text]');
      const cursor = section.querySelector('[data-osb-cursor]');
      const soundButton = section.querySelector('[data-osb-sound]');
      let activePlayer = null;
      let activeType = null;
      let soundEnabled = false;
      let introTimer = null;

      const candidates = [];
      if (nativeTemplate) candidates.push({ type: 'native' });
      if (options?.dataset.osbWednesdaysVimeo) {
        candidates.push({
          type: 'vimeo-wednesdays',
          id: options.dataset.osbWednesdaysVimeo,
          hash: options.dataset.osbWednesdaysHash
        });
      }
      if (options?.dataset.osbCupVimeo) {
        candidates.push({ type: 'vimeo-cup', id: options.dataset.osbCupVimeo });
      }

      if (candidates.length && media) {
        const storageKey = `osb-last-video-${section.id}`;
        let lastType = null;
        try { lastType = sessionStorage.getItem(storageKey); } catch (error) { /* Storage can be unavailable. */ }
        const pool = candidates.length > 1 ? candidates.filter((item) => item.type !== lastType) : candidates;
        const selected = pool[Math.floor(Math.random() * pool.length)] || candidates[0];
        activeType = selected.type;

        if (selected.type === 'native') {
          const video = nativeTemplate.content.firstElementChild.cloneNode(true);
          activePlayer = video;
          media.prepend(video);
          video.addEventListener('loadedmetadata', () => {
            if (video.videoWidth && video.videoHeight) {
              media.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`;
            }
          }, { once: true });
          video.play().catch(() => {});
        } else if (selected.type === 'vimeo-wednesdays') {
          media.style.aspectRatio = '16 / 9';
          const iframe = document.createElement('iframe');
          iframe.className = 'osb-landing__embed is-loading';
          iframe.title = '52 Wednesdays Deep';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.tabIndex = -1;

          const hashParameter = selected.hash ? `&h=${encodeURIComponent(selected.hash)}` : '';
          iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(selected.id)}?autoplay=1&muted=1&loop=0&autopause=0&controls=0&playsinline=1&dnt=1${hashParameter}`;
          media.prepend(iframe);

          loadOsbVimeoApi().then(async (Vimeo) => {
            const player = new Vimeo.Player(iframe);
            activePlayer = player;

            const chooseRandomStart = async () => {
              const duration = Math.floor(await player.getDuration());
              const latestStart = Math.max(51, duration - 15);
              const randomStart = Math.floor(51 + Math.random() * (latestStart - 51 + 1));
              await player.setCurrentTime(randomStart);
            };

            await player.ready();
            await player.setMuted(true);
            await player.setVolume(0);
            await chooseRandomStart();
            await player.play();
            iframe.classList.remove('is-loading');

            player.on('ended', async () => {
              await chooseRandomStart();
              await player.play();
            });
          }).catch(() => iframe.classList.remove('is-loading'));
        } else {
          const iframe = document.createElement('iframe');
          iframe.className = 'osb-landing__embed';
          iframe.title = 'The CsCb Cup Ad';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.tabIndex = -1;

          media.style.aspectRatio = '100 / 60.55';
          iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(selected.id)}?autoplay=1&muted=1&loop=1&autopause=0&background=1&controls=0&dnt=1`;

          activePlayer = iframe;
          media.prepend(iframe);
        }

        try { sessionStorage.setItem(storageKey, selected.type); } catch (error) { /* Storage can be unavailable. */ }
      }

      function updateSoundLabel() {
        const onLabel = soundButton?.querySelector('[data-osb-sound-on]');
        const offLabel = soundButton?.querySelector('[data-osb-sound-off]');
        if (onLabel) onLabel.hidden = soundEnabled;
        if (offLabel) offLabel.hidden = !soundEnabled;
        soundButton?.setAttribute('aria-pressed', String(soundEnabled));
      }

      function toggleSound() {
        if (!activePlayer || !activeType) return;
        soundEnabled = !soundEnabled;

        if (activeType === 'native') {
          activePlayer.muted = !soundEnabled;
          activePlayer.volume = soundEnabled ? 1 : 0;
          activePlayer.play().catch(() => {});
        } else if (activeType === 'vimeo-wednesdays') {
          if (soundEnabled) {
            activePlayer.setMuted(false);
            activePlayer.setVolume(1);
            activePlayer.play();
          } else {
            activePlayer.setMuted(true);
            activePlayer.setVolume(0);
          }
        } else if (activeType === 'vimeo-cup') {
          activePlayer.contentWindow?.postMessage({ method: 'setVolume', value: soundEnabled ? 1 : 0 }, '*');
          if (soundEnabled) activePlayer.contentWindow?.postMessage({ method: 'play' }, '*');
        }

        updateSoundLabel();
      }

      soundButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        toggleSound();
      });

      function updateJoinReadiness() {
        if (!requiredFields.length || !joinButton) return;
        const isReady = requiredFields.every((field) => field.checkValidity());
        joinButton.classList.toggle('is-ready', isReady);
      }

      requiredFields.forEach((field) => {
        field.addEventListener('input', updateJoinReadiness);
        field.addEventListener('change', updateJoinReadiness);
      });

      function dismissIntro() {
        if (introTimer) window.clearTimeout(introTimer);
        intro?.classList.add('is-dismissed');
      }

      function startIntro() {
        if (!intro || !introTextNode) return;
        const text = intro.dataset.text || '';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const fitIntroText = () => {
          const currentText = introTextNode.textContent;
          intro.style.removeProperty('font-size');
          introTextNode.textContent = text;
          const availableWidth = intro.clientWidth;
          const measuredWidth = introTextNode.getBoundingClientRect().width;
          const maximumSize = Number.parseFloat(window.getComputedStyle(intro).fontSize);

          if (availableWidth && measuredWidth > availableWidth && maximumSize) {
            intro.style.fontSize = `${maximumSize * (availableWidth / measuredWidth) * 0.985}px`;
          }

          introTextNode.textContent = currentText;
        };

        fitIntroText();
        window.addEventListener('resize', fitIntroText, { passive: true });

        if (reduceMotion) {
          introTextNode.textContent = text;
          return;
        }

        let index = 0;
        const typeNextCharacter = () => {
          if (intro.classList.contains('is-dismissed')) return;
          introTextNode.textContent = text.slice(0, index);
          index += 1;

          if (index <= text.length) {
            introTimer = window.setTimeout(typeNextCharacter, 55);
          } else {
            introTimer = null;
          }
        };

        introTimer = window.setTimeout(typeNextCharacter, 550);
      }

      joinButton?.addEventListener('click', () => {
        if (!joinPanel) return;

        if (joinPanel.hidden) {
          dismissIntro();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const startPosition = joinButton.getBoundingClientRect();
          joinPanel.hidden = false;
          joinButton.setAttribute('aria-expanded', 'true');
          joinButton.classList.add('is-form-open');

          if (reduceMotion) {
            joinPanel.classList.add('is-open');
            updateJoinReadiness();
            return;
          }

          const endPosition = joinButton.getBoundingClientRect();
          const offsetX = startPosition.left - endPosition.left;
          const offsetY = startPosition.top - endPosition.top;

          joinButton.style.transition = 'none';
          joinButton.style.transform = `translate(${offsetX}px, ${offsetY}px)`;

          requestAnimationFrame(() => {
            joinPanel.classList.add('is-open');
            updateJoinReadiness();
            requestAnimationFrame(() => {
              joinButton.style.transition = 'color 260ms ease, transform 850ms cubic-bezier(0.22, 1, 0.36, 1)';
              joinButton.style.transform = 'translate(0, 0)';
            });
          });

          const onJoinMoveEnd = (event) => {
            if (event.propertyName !== 'transform') return;
            joinButton.style.removeProperty('transition');
            joinButton.style.removeProperty('transform');
            joinButton.removeEventListener('transitionend', onJoinMoveEnd);
          };
          joinButton.addEventListener('transitionend', onJoinMoveEnd);
        } else if (joinForm && !section.querySelector('[data-osb-success]')) {
          joinForm.requestSubmit();
        }
      });

      if (section.querySelector('[data-osb-success], [data-osb-errors]') && joinPanel) {
        dismissIntro();
        joinPanel.hidden = false;
        joinPanel.classList.add('is-open');
        joinButton?.classList.add('is-form-open');
        joinButton?.setAttribute('aria-expanded', 'true');
        updateJoinReadiness();

        if (section.querySelector('[data-osb-success]')) {
          requestAnimationFrame(() => joinButton?.classList.add('is-complete'));
        }
      } else {
        startIntro();
      }

      section.addEventListener('pointermove', (event) => {
        if (!cursor || event.pointerType === 'touch') return;
        cursor.style.left = `${event.clientX}px`;
        cursor.style.top = `${event.clientY}px`;
        cursor.classList.add('is-visible');
      });
      section.addEventListener('pointerleave', () => cursor?.classList.remove('is-visible'));
      section.addEventListener('pointerdown', () => cursor?.classList.add('is-active'));
      section.addEventListener('pointerup', () => cursor?.classList.remove('is-active'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOsbLandings());
  } else {
    initOsbLandings();
  }

  document.addEventListener('shopify:section:load', (event) => initOsbLandings(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osb-player-finder"] && !Shopify.designMode) return;
  try {
    
  function initOsbFinders(scope = document) {
    scope.querySelectorAll('[data-osb-finder]:not([data-osb-finder-ready])').forEach((section) => {
      section.setAttribute('data-osb-finder-ready', '');

      const panel = section.querySelector('[data-osb-finder-panel]');
      const form = section.querySelector('[data-osb-finder-form]');
      const trigger = section.querySelector('[data-osb-finder-trigger]');
      const chessInput = section.querySelector('[data-osb-chess]');
      const cityInput = section.querySelector('[data-osb-city]');
      const privateLevelInput = section.querySelector('[data-osb-private-level]');
      const results = section.querySelector('[data-osb-results]');
      const status = section.querySelector('[data-osb-status]');
      const matches = section.querySelector('[data-osb-matches]');
      const profileTemplate = section.querySelector('[data-osb-profile-source]');
      const cursor = section.querySelector('[data-osb-finder-cursor]');
      const requiredFields = form ? Array.from(form.querySelectorAll('input[required]')) : [];

      const normalize = (value) => value.toLowerCase().replace(/^@/, '').trim();
      const normalizeCity = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const levelOrder = ['i dabble', "i'm aight", 'bang out'];

      function updateReadiness() {
        const ready = requiredFields.length && requiredFields.every((field) => field.checkValidity());
        trigger?.classList.toggle('is-ready', ready);
      }

      requiredFields.forEach((field) => {
        field.addEventListener('input', updateReadiness);
        field.addEventListener('change', updateReadiness);
      });

      function openMatcher() {
        if (!panel || !trigger) return;
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => panel.classList.add('is-open'));
        window.setTimeout(() => chessInput?.focus(), 450);
      }

      function ratingFromStats(stats) {
        const ratings = ['chess_rapid', 'chess_blitz', 'chess_bullet']
          .map((key) => stats?.[key]?.last?.rating)
          .filter((rating) => Number.isFinite(rating));
        return ratings.length ? Math.max(...ratings) : null;
      }

      function privateLevelFromRating(rating) {
        if (rating === null || rating < 1000) return 'i dabble';
        if (rating < 1600) return "i'm aight";
        return 'bang out';
      }

      async function getPrivateLevel(username) {
        const response = await fetch(`https://api.chess.com/pub/player/${encodeURIComponent(username)}/stats`);
        if (!response.ok) throw new Error('check that chess.com @.');
        const stats = await response.json();
        return privateLevelFromRating(ratingFromStats(stats));
      }

      function findMatches(city, level, username) {
        if (!profileTemplate) return [];
        const cityKey = normalizeCity(city);
        const levelIndex = Math.max(0, levelOrder.indexOf(level));

        return Array.from(profileTemplate.content.querySelectorAll('[data-osb-profile]'))
          .filter((profile) => normalize(profile.dataset.chess || '') !== username)
          .map((profile) => {
            const profileLevel = normalize(profile.dataset.level || 'i dabble').replace('i’m', "i'm");
            const profileLevelIndex = Math.max(0, levelOrder.indexOf(profileLevel));
            const sameCity = normalizeCity(profile.dataset.city || '') === cityKey;
            const levelDistance = Math.abs(profileLevelIndex - levelIndex);
            return {
              profile,
              sameCity,
              score: (sameCity ? 100 : 0) + (2 - levelDistance) * 10
            };
          })
          .filter((candidate) => candidate.sameCity)
          .sort((first, second) => second.score - first.score)
          .slice(0, 3);
      }

      function showMatches(found, city) {
        if (!results || !status || !matches) return;
        matches.replaceChildren();
        status.textContent = found.length ? 'your game.' : `no match in ${city.trim()} yet.`;
        found.forEach(({ profile }) => matches.appendChild(profile.cloneNode(true)));
        results.hidden = false;
        requestAnimationFrame(() => results.classList.add('is-visible'));
      }

      function sendProfileRequest() {
        if (!form) return;
        const data = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        }).catch(() => {});
      }

      async function runMatcher() {
        if (!form || !trigger || !chessInput || !cityInput) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const username = normalize(chessInput.value);
        const city = cityInput.value.trim();
        trigger.classList.add('is-working');
        trigger.textContent = 'finding…';

        try {
          const level = await getPrivateLevel(username);
          if (privateLevelInput) privateLevelInput.value = level;
          const found = findMatches(city, level, username);
          showMatches(found, city);
          sendProfileRequest();
          trigger.textContent = 'find again';
        } catch (error) {
          if (results && status && matches) {
            matches.replaceChildren();
            status.textContent = error instanceof Error ? error.message : 'try again.';
            results.hidden = false;
            requestAnimationFrame(() => results.classList.add('is-visible'));
          }
          trigger.textContent = 'find a game';
        } finally {
          trigger.classList.remove('is-working');
        }
      }

      trigger?.addEventListener('click', () => {
        if (panel?.hidden) {
          openMatcher();
        } else {
          runMatcher();
        }
      });

      section.addEventListener('pointermove', (event) => {
        if (!cursor || event.pointerType === 'touch') return;
        cursor.style.left = `${event.clientX}px`;
        cursor.style.top = `${event.clientY}px`;
        cursor.classList.add('is-visible');
      });
      section.addEventListener('pointerleave', () => cursor?.classList.remove('is-visible'));
      section.addEventListener('pointerdown', () => cursor?.classList.add('is-active'));
      section.addEventListener('pointerup', () => cursor?.classList.remove('is-active'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOsbFinders());
  } else {
    initOsbFinders();
  }

  document.addEventListener('shopify:section:load', (event) => initOsbFinders(event.target));

  } catch(e) { console.error(e); }
})();
})();
